module.exports = __webpack_public_path__ + "static/img/banner.1ae75fa.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/preview/banner.jpeg
// module id = yvHF
// module chunks = 1